import { useQuery } from 'react-query'
import { AxiosInstance } from 'axios'

import { User } from '@dc-shared-web/hooks/api/user'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

const QUERY_KEY = ['User']

const fetchAuthUser = async (apiClient: AxiosInstance): Promise<User> => {
  const {
    data: { data },
  } = await apiClient.get(`/api/secure/user?getDisclaimer=true`)

  return data
}

export const useGetAuthUser = (params?: { enabled?: boolean }) => {
  const apiClient = useAxiosContext()

  return useQuery<User, Error>(QUERY_KEY, () => fetchAuthUser(apiClient), {
    retry: false,
    enabled: params?.enabled ?? true,
  })
}
